import React from "react";
import EquipmentCard from "./EquipmentCard";
import AddUnitCard from "./AddUnitCard";

const climateTypes = ["cool_unit", "dehumidifier", "fogger"];

export default function ClimateZone({ controls, actions }) {
  return (
    <div className="zone-container climate-zone">
      <h3 className="zone-title">Climate — Ceiling / Upper Wall</h3>
      {climateTypes.map((eqType) => {
        const units = controls.equipment.filter((e) => e.type === eqType);
        return (
          <div key={eqType}>
            <div className="equipment-row">
              {units.map((eq) => (
                <EquipmentCard
                  key={eq.id}
                  equipment={eq}
                  eligible={actions.getEligible(eq.id)}
                  onStageChange={actions.setStage}
                  onAttachSensor={actions.attachSensor}
                  onDetachSensor={actions.detachSensor}
                  onRemove={actions.removeEquipment}
                />
              ))}
              <AddUnitCard eqType={eqType} onAdd={actions.addEquipment} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
